import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { isIterableArray, replacedString, toFormatPrice } from '../../../utils/utils'
import TableSortingCreator from '../../tableHelpers/TableSortingCreator'
import TableBalanceDumb from './TableBalanceDumb'


export type BalanceRowType = {
    date: string,
    date_sort: string,
    amount_cl: number,
    balance_cl: number,
    action: string,
}

const TableBalance = ({ data, search }: { data: BalanceRowType[], search: string }) => {

    const { t } = useTranslation()


    const [rows, setRows] = useState<BalanceRowType[]>([]);
    const [tableRows, setTableRows] = useState<BalanceRowType[]>([]);

    const onSearch = (searchValue: string) => {
        const reg = new RegExp(replacedString(searchValue), "gi");
        if (searchValue === "") {
            setTableRows(rows)
            return
        }

        if (isIterableArray(rows)) {
            const filteredData: any[] = rows.filter((item: any) => {
                const keys = Object.keys(item);
                let matches = 0;
                keys.forEach((key) => {
                    let val = replacedString(String(item[key]))
                    if (reg.test(val)) matches++;
                });
                return matches > 0;
            });
            if (searchValue !== "" && filteredData.length > 0) {
                setTableRows(filteredData);
            }
            if (searchValue !== "" && filteredData.length === 0) {
                setTableRows([]);
            }
        }


    };

    // ______CREATE_DATA
    useEffect(() => {
        if (isIterableArray(data)) {
            const res: BalanceRowType[] = data.map((item: BalanceRowType) => createData(item))
            setRows(res)
        }
        else setRows([])
    }, [data]);

    useEffect(() => {
        onSearch(search)
    }, [rows, search]);



    function createData(data: BalanceRowType) {
        return {
            date: data.date,
            date_sort: data.date_sort,
            amount_cl: data.amount_cl,
            balance_cl: data.balance_cl,
            action: t(`contract_page.view_balances_${data.action}`)
        };
    }

    return (
        isIterableArray(tableRows) ?
            <div className='overflow-auto max-h-[calc(100vh-400px)]'>
                <TableSortingCreator
                    isLoadingTable={false}
                    Component={TableBalanceDumb}
                    rows={tableRows}
                    defaultOrderBy="date_sort"
                    hidePerPageSelect
                    defaultRowsPerPage={100}
                />
            </div>
            :
            <div className='py-[10px]'>
                <p className={`text-center text-[14px] lap:text-[18px] text-gray-600`}>
                    {
                        search
                            ?
                            <> {t('contract_page.view_balances_no_data_by_search')} "{search}"</>
                            :
                            t('contract_page.view_balances_no_data')
                    }
                </p>
            </div>
    )
}

export default TableBalance